import { render, staticRenderFns } from "./VisionAndMission.vue?vue&type=template&id=04189140&"
import script from "./VisionAndMission.vue?vue&type=script&lang=js&"
export * from "./VisionAndMission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports